export default __webpack_public_path__ + "static/media/Close-Sound.2f802531.png";